import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');
var serviceName = "index";
var projeKategoriService = {
    pKategoriTanimlama(link, icon, baslik,dil) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                link: link,
                icon: icon,
                baslik: baslik,
                dil: dil,
                serviceName: "proje",
                methodName: "pKategoriTanimlama"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    pKategoriDetay(pkategoriId) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                pkategoriId: pkategoriId,
                serviceName: "proje",
                methodName: "pKategoriDetay"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },


    pKategoriListesi(durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                durum: durum,
                dil: "",
                serviceName: "proje",
                methodName: "pKategoriListesi"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    pKategoriDurumGuncelle(pkategoriId, durum) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                pkategoriId: pkategoriId,
                durum: durum,
                serviceName: "proje",
                methodName: "pKategoriDurumGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    pKategoriGuncelle(pkategoriId, link, icon, baslik, dil) {
        var userDataExon = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataExon"))));
        var param = {
            data: {
                yonetimId: userDataExon["yonetimId"],
                userToken: userDataExon["token"],
                firmaKodu: userDataExon["firmaKodu"],
                pkategoriId: pkategoriId,
                link: link,
                icon: icon,
                baslik: baslik,
                dil: dil,
                serviceName: "proje",
                methodName: "pKategoriGuncelle"

            }
        };
        var result = new Promise(function (resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

}

export default projeKategoriService

